// src/components/ui/FilterBar.jsx
// Collapsible filter toolbar, generalized from the best existing pattern
// in the codebase (admin/accounting/components/AccountingFilterSection.jsx)
// so non-accounting pages can adopt the same collapsible-panel +
// active-filter-count badge UX in Giai đoạn 3, instead of the legacy
// DOM-driven lib-filter.js modal pattern.
//
// The accounting module keeps using its own AccountingFilterSection.jsx
// unchanged — this is a separate, generic component for everyone else.
import React from "react";
import { Button, Form } from "react-bootstrap";
import { FaChevronDown, FaFilter, FaSyncAlt } from "react-icons/fa";
import "./filterBar.css";

const FilterBar = ({
  title,
  open,
  onToggle,
  onSubmit,
  onReset,
  activeCount = 0,
  toolbarRight = null,
  children,
  closeOnSubmit = true,
}) => {
  const hasFilters = activeCount > 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(e);
    if (closeOnSubmit && onToggle) {
      onToggle(false);
    }
  };

  return (
    <div className="zto-filter-bar">
      <div className="zto-filter-bar__toolbar">
        <div className="zto-filter-bar__toolbar-left">
          {title && <h5 className="mb-0 fw-bold">{title}</h5>}
          <Button
            type="button"
            variant="outline-primary"
            size="sm"
            className={`zto-filter-bar__toggle ${open ? "is-open" : ""} ${hasFilters ? "has-filters" : ""}`}
            onClick={() => onToggle?.(!open)}
          >
            <FaFilter />
            Bộ lọc
            {activeCount > 0 && <span className="zto-filter-bar__badge">{activeCount}</span>}
            <FaChevronDown className="zto-filter-bar__chevron" />
          </Button>
        </div>
        {toolbarRight && <div className="zto-filter-bar__toolbar-right">{toolbarRight}</div>}
      </div>

      <div className={`zto-filter-bar__panel ${open ? "is-open" : ""}`}>
        <div className="zto-filter-bar__panel-inner">
          <Form onSubmit={handleSubmit}>
            {children}
            <div className="zto-filter-bar__actions">
              <Button type="submit" variant="primary" size="sm">
                <FaFilter className="me-1" />
                Lọc
              </Button>
              <Button type="button" variant="outline-secondary" size="sm" onClick={onReset}>
                <FaSyncAlt />
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
